// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__-4H6x","buttons":"SendReceipts_buttons__3x066","email":"SendReceipts_email__3l9qZ","bookApptTitle":"SendReceipts_bookApptTitle__22Zhc"};